import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SAMU, useChartsData } from '../../../../Common/hooks/useChartsData';


export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children , module }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SAMU.PERIOD,
            url: 'governanceroom/dashboardsamu/results/period'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value
        }
    );

    const chartData = data
        ? {
              annualOcurrencesEvolution:
                  data?.annualOcurrencesEvolution ?? [],
              monthlyOcurrencesEvolution:
                  data?.monthlyOcurrencesEvolution ?? [],
              ocurrencesByDay:
                  data?.weeklyOcurrencesEvolution ?? [],
              ocurrencesByHour:
                  data?.ocurrencesByHour ?? []
          }
        : {
              annualOcurrencesEvolution: [],
              monthlyOcurrencesEvolution: [],
              ocurrencesByDay: [],
              ocurrencesByHour: []
          };

    const colors = ['#1F77B4', '#FF7F0E'];

    const subtitles = ["", ""];

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                module,
                colors,
                subtitles,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
